import React, { useState, useEffect } from 'react'
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";
import HomeBanner from './HomeBanner'
import HomeMessage from './HomeMessage'
import HomeAbout from './HomeAbout'
import HomeWhat from './HomeWhat'
import HomeCounter from './HomeCounter'
import HomeProject from './HomeProject'
import HomeWork from './HomeWork'
import HomeLogoslider from './HomeLogoslider'
import HomeTestimonial from './HomeTestimonial'
import HomeTeam from './HomeTeam'
import HomeBlog from './HomeBlog'
import LandingGallery from '../LandingPage/LandingGallery';
import LandingCraft from '../LandingPage/LandingCraft';
import LandingSolve from '../LandingPage/LandingSolve';

export default function Home({ initialData }) {
    const [homeData, setHomeData] = useState(initialData?.home || []);

    useEffect(() => {
      const dataFetcher = async () => {
        try {
          const res = await axios.get(`${BaseUrl}/api/home`);
          setHomeData(res.data?.homes?.[0] ?? null);
        } catch (err) {
          console.error("Home API error:", err);
          setHomeData(null);
        }
      };

      dataFetcher();
    }, []);


  return (
    <>
      <HomeBanner homeData={homeData}/>
      <HomeMessage homeData={homeData}/>
      <HomeAbout homeData={homeData}/>
      <HomeWhat/>
      <HomeCounter initialData={initialData?.Home_our_stat}/>
      <LandingCraft/> 
      {/* <HomeProject initialData={initialData?.projects}/> */}
      <LandingGallery/>
      <HomeWork initialData={initialData?.how_we_works}/>
      <LandingSolve/>
      <HomeLogoslider initialData={initialData?.home_client_logos}/>
      <HomeTestimonial category={null} initialData={initialData?.Home_testimonial_sections}/>
      <HomeTeam/>
      <HomeBlog initialData={initialData?.blogs}/>
    </>
  )
}
